const isDebug = process.env.REACT_APP_DEBUG_MODE === 'true';

// eslint-disable-next-line no-console
export const debugLog = (...args) => isDebug && console.log(...args);
// eslint-disable-next-line no-console
export const debugError = (...args) => isDebug && console.error(...args);
// eslint-disable-next-line no-console
export const debugWarn = (...args) => isDebug && console.warn(...args);
// eslint-disable-next-line no-console
export const debugTable = (...args) => isDebug && console.table(...args);
// eslint-disable-next-line no-console
export const debugGroup = (...args) => isDebug && console.group(...args);
// eslint-disable-next-line no-console
export const debugGroupEnd = () => isDebug && console.groupEnd();
